// extracted by mini-css-extract-plugin
module.exports = {"VideoPreview":"VideoPreview_VideoPreview__y7Mop"};